<template>
  <v-flex xs12 class="header" :style="headerStyle">
    <email-form />
    <template>
      <v-toolbar dark class="mobile-menu" :fixed="windowWidth < windowHeight">
        <v-btn icon depressed flat @click="goBack">
          <v-icon large>chevron_left</v-icon>
        </v-btn>
        <div
          style="cursor:pointer; "
          @click="goBack"
        >
          <b>
            {{ capitalize($i18n.t('back')) }}
          </b>
        </div>

        <v-spacer></v-spacer>
        <div class="mobile-header-object-title">
          <b>{{ selectedObject && selectedObject.objectName }}</b>
        </div>
        <v-spacer></v-spacer>
        <div class="justify-end">
          <v-btn icon depressed flat @click="mobileShare()">
            <v-icon small>fa-share</v-icon>
          </v-btn>
        </div>
        <v-toolbar-side-icon @click="showRightMenu = !showRightMenu"></v-toolbar-side-icon>
      </v-toolbar>
    </template>
  </v-flex>
</template>

<script>
import EmailForm from './_EmailForm'
import sharedMethods from './../methods/sharedMethods'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'PageHeaderMobile',

  components: {
    EmailForm
  },

  computed: {
    ...mapFields(Object.keys(state)),

    headerStyle () {
      return {
      }
    }
  },

  methods: {
    ...sharedMethods,

    goBack () {
      window.history.back()
    }
  }
}
</script>

<style>
.mobile-menu .v-toolbar__content {
  height: 48px !important;
}
.mobile-weather-img {
  width: 30px;
}
.mobile-temp-value {
  font-size: 14px;
  color: white;
  text-align: right;
  font-weight: bold;
  padding-right: 5px;
}
.mobile-temp-img, .mobile-temp-text {
  float: right;
}
.mobile-temp-text {
  padding-top: 10px;
  padding-right: 10px;
}
.mobile-temp-img {
  padding-top: 5px;
}
.theme--dark.v-toolbar {
  background-color: inherit !important;
}
.mobile-menu .theme--dark.v-toolbar {
  background-color: inherit !important;
}
.v-toolbar {
  background: url(/img/menu_bg.jpg) repeat 0 top;
}
.mobile-logo {
  padding-top: 58px;
  text-align: center;
}
.mobile-logo a img {
  max-height: 95px;
}
.mobile-flags {
  text-align: center;
}
.mobile-flags a {
  padding: 0 3px;
}
.mobile-flags a img {
  width: 25px;
  padding-top: 5px;
}
.temp_value {
  position: relative;
  top: -15px;
  font-size: 20px;
  color: white;
  font-weight: bold;
  margin: 0;
  padding: 0;
}
.mobile-header-object-title {
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 10px;
  overflow: hidden;
}
</style>
